export default {
  addStoreItem(state, payload) {
    state[payload.category].push(payload.item)
  },

  setFeaturedArticles(state, payload) {
    state.featuredArticles = payload
  },

  resetAllStoreItems(state) {
    state.appIsInitialized = false
    state.initialSecondaryFilterSetup = true
    state.cards = []
    state.cardsFiltered = []
    state.cardsFilteredDisplayed = []
    state.currentUrl = ''
    state.primaryFilters = []
    state.resultsNumberHistory = [0]
    state.activePrimaryFilters = []
    state.secondaryFilters = []
    state.subPages = []
    state.itemFilters.selected = {}
    state.itemFilters.results = {}
    state.variantFilters.selected = {}
    state.variantFilters.results = {}
    state.allFilters = []
  },

  selectCard(state, payload) {
    state.selectedCardIndex = payload
    state.selectedCard = state.cards[payload] !== undefined ? state.cards[payload] : {}
  },

  setItemFilterOption(state, payload) {
    state.itemFilters.selected[payload.id] = payload.value
  },

  setItemResults(state, payload) {
    state.itemFilters.results[payload.id] = payload.value
  },

  setTopBanner(state, payload) {
    state.topBanner = payload
  },

  // TODO: Remove once A/B test is over #DY-FILTER-PAGE-SHORT-PRODUCT-DESCRIPTION
  setPreferredCardSummary(state, payload) {
    state.preferredCardSummary = { ...state.preferredCardSummary, ...payload }
  },

  setFilteredVariants(state, payload) {
    const index = state.cardsFiltered.findIndex(card => card.id === payload.id)
    state.cardsFiltered[index].variants = payload.variants
  },

  setVariantFilterOption(state, payload) {
    state.variantFilters.selected[payload.id] = payload.value
  },

  setUnselectedFilter(state, payload) {
    state.unselectedFilter = payload
  },

  setSortingRule(state, payload) {
    state.currentSorting = payload
  },

  setBasePath(state, payload) {
    const basePathWithTrailingSlash = payload.replace(/\/?$/, '/')
    state.basePath = basePathWithTrailingSlash
  },

  initializeFilters(state, payload) {
    state[payload.category].selected[payload.id] = payload.order === 'primary' ? [''] : []
    state[payload.category].results[payload.id] = []
  },

  resetDisplayedFilteredCards(state) {
    if (!state.cardsFiltered.length) {
      state.noResults = true
    } else {
      state.noResults = false
      state.cardsFilteredDisplayed = []
    }
  },

  setFilteredCards(state, payload) {
    state.cardsFiltered = payload
    state.resultsNumberHistory.unshift(payload.length)
  },

  setCardsFilteredWithPromos(state, payload) {
    state.cardsFilteredWithPromos = payload
  },

  setVariantNumberHistory(state, payload) {
    state.variantNumberHistory.unshift(payload)
  },

  setActiveSubPage(state, payload) {
    state.activeSubPage = payload
  },

  switchDisplayedCards(state) {
    state.noResults = false
    state.cardsFilteredDisplayed = state.cardsFilteredWithPromos
  },

  setActivePrimaryFilters(state, payload) {
    let index = state.activePrimaryFilters.findIndex(filter => filter.hasOwnProperty(payload.id))
    let obj = {}
    obj[payload.id] = payload.value[0]
    index === -1
      ? state.activePrimaryFilters.push(obj)
      : state.activePrimaryFilters.splice(index, 1, obj)
  },

  setCurrentBreakpoint(state, payload) {
    state.currentBreakpoint = payload
  },

  initializeActivePrimaryFilters(state) {
    state.activePrimaryFilters = state.primaryFilters.map(filter => {
      return {
        [filter.id]: '',
      }
    })
  },

  setHiddenSecondaries(state, payload) {
    state.hiddenSecondaries = payload
  },

  addToPathFilters(state, payload) {
    state.pathFilters = payload
  },

  addToQueryFilters(state, payload) {
    state.queryFilters = payload
  },

  setActiveCardsNumber(state, payload) {
    state.activeCardsNumber = payload
  },

  setCurrentUrl(state, payload) {
    state.currentUrl = payload
  },

  broadcastFilterReset(state) {
    state.globalFilterReset = true
    setTimeout(() => {
      state.globalFilterReset = false
    }, 500)
  },

  broadcastFilterStateUpdate(state) {
    // Notify filters to update their selected state according to the selected state in the store
    state.globalFilterStateUpdate = true
    setTimeout(() => {
      state.globalFilterStateUpdate = false
    }, 500)
  },

  trackPageViews(state, payload) {
    state.pageviewsAreTracked = payload
  },

  toggleFilterOverlay(state, payload) {
    state.filterOverlayIsOpen = payload === undefined ? !state.filterOverlayIsOpen : payload
  },

  toggleSortingOverlay(state, payload) {
    state.sortingOverlayIsOpen = payload === undefined ? !state.sortingOverlayIsOpen : payload
  },

  setIsMobile(state, payload) {
    state.isMobile = payload
  },

  setTags(state, payload) {
    state.tags = payload
  },
}
